module.exports = __webpack_public_path__ + "static/media/order-management-guide.7e02fc83a755904629114865ff9ec982.png";